
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rdv/return",
      function () {
        return require("private-next-pages/rdv/return.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rdv/return"])
      });
    }
  